var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"notFound"},[_c('doc-post',[_c('div',{staticClass:"sorry"},[_c('img',{attrs:{"src":require("../../assets/images/sorry.jpg"),"alt":"404"}})]),_c('div',{staticClass:"tipNum"},[_c('span',[_vm._v(_vm._s(_vm.count))])])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }